<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        <v-row>
                            <p>گزارش کارکرد کامیونداران</p>

                        </v-row>

                    </v-card-title>
                    <v-card-title>

                        <v-col cols="3">
                            <v-select
                                    dense
                                    id="truck_type"
                                    v-model="report_type"
                                    :items="[{label:'نمایش کل کارکرد کامیونداران',value:1},{label:'نمایش کل کارکرد کامیونداران(به تفکیک)',value:4},{label:'ریز کارکرد کامیونداران',value:2},{label:'پرینت کارکرد کامیون های انتخابی',value:3}]"
                                    item-value="value"
                                    item-text="label"
                            />
                        </v-col>
                    </v-card-title>
                    <v-card-text v-if="report_type==1">
                        <div class="container">
                            <v-row>

                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label class="col-form-label">
                                            از تاریخ
                                        </label>
                                        <div>
                                            <ThreeDatePicker @last_focus="another_focus_select('end_date_id_date_day')"
                                                             first_id="start_date_id_" v-model="start_date"/>
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label class="col-form-label">
                                            تا تاریخ
                                        </label>
                                        <div>
                                            <ThreeDatePicker
                                                    @last_focus="another_focus_inside('trucks1')"
                                                    first_id="end_date_id_" v-model="end_date"/>
                                        </div>
                                    </v-row>
                                </v-col>

                                <v-col cols="3">
                                    <v-row form class="form-group">
                                        <div dir="rtl">
                                            <treeselect
                                                    :matchKeys="['code']"
                                                    v-model="start_selected_truck"
                                                    :cacheOptions="false"
                                                    :options="trucks_all"
                                                    :multiple="true"
                                                    id="trucks1"
                                                    :defaultExpandLevel="1"
                                                    placeholder="جستجو کامیون"
                                                    :normalizer="normalizer_load_type"
                                            />
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col cols="1">
                                    <v-btn @click="get_data_all" small color="primary">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <div :id="body_id">
                                <div v-if="items_delivery_all.length>0">

                                    <VDataTable2
                                            dense
                                            fixed-header
                                            multi-sort
                                            height="400px"
                                            hide-default-footer
                                            disable-pagination
                                            class="margin-auto table-bordered"
                                            :headers="headers_deliver_all"
                                            :items-per-page="1000"
                                            :items="items_delivery_all"
                                    >
                                        <template v-slot:item.row_id="{item }">
                                            {{ item._row_index+1}}
                                        </template>
                                        <template v-slot:item.total_driver_price="{ item }">
                                            {{ get_currency(parseFloat(item.total_driver_price).toFixed(0) )}}
                                        </template>
                                        <template v-slot:item.total_employer_price="{ item }">
                                            {{ get_currency(parseFloat(item.total_employer_price).toFixed(0))}}
                                        </template>
                                        <template v-slot:item.total_real_driver_price="{ item }">
                                            {{ get_currency(parseFloat(item.total_real_driver_price).toFixed(0)) }}
                                        </template>
                                        <template v-slot:item.total_real_employer_price="{ item }">
                                            {{ get_currency(parseFloat(item.total_real_employer_price).toFixed(0))
                                            }}
                                        </template>
                                        <template slot="body.append">

                                            <tr class="pink--text">
                                                <th colspan="4" class="title">جمع کل</th>
                                                <th class="title">{{get_currency(calculate_items(items_delivery_all,
                                                    'count_truck'))}}
                                                </th>
                                                <th class="title">{{get_currency(calculate_items(items_delivery_all,
                                                    'total_tonaje'))}}
                                                </th>
                                                <th class="title">{{get_currency(calculate_items(items_delivery_all,
                                                    'total_employer_price'))}}
                                                </th>
                                                <th class="title">{{get_currency(calculate_items(items_delivery_all,
                                                    'total_real_employer_price'))}}
                                                </th>
                                                <th class="title">{{get_currency(calculate_items(items_delivery_all,
                                                    'total_driver_price'))}}
                                                </th>
                                                <th class="title">{{get_currency(calculate_items(items_delivery_all,
                                                    'total_real_driver_price'))}}
                                                </th>

                                            </tr>
                                        </template>
                                    </VDataTable2>
                                    <v-row style="text-align:right">
                                        <v-col cols="12">تعداد سرویس: {{get_currency(calculate_items(items_delivery_all,
                                            'count_truck'))}}
                                        </v-col>
                                        <v-col cols="12">جمع تناژ: {{get_currency(calculate_items(items_delivery_all,
                                            'total_tonaje'))}}
                                        </v-col>
                                        <v-col cols="12">جمع مبلغ کارفرما:
                                            {{get_currency(calculate_items(items_delivery_all,
                                            'total_employer_price'))}}
                                        </v-col>
                                        <v-col cols="12">جمع مبلغ مورد محاسبه کارفرما:
                                            {{get_currency(calculate_items(items_delivery_all,
                                            'total_real_employer_price'))}}
                                        </v-col>
                                        <v-col cols="12">جمع مبلغ کامیوندار:
                                            {{get_currency(calculate_items(items_delivery_all, 'total_driver_price'))}}
                                        </v-col>
                                        <v-col cols="12">جمع مبلغ مورد محاسبه کامیوندار:
                                            {{get_currency(calculate_items(items_delivery_all,
                                            'total_real_driver_price'))}}
                                        </v-col>
                                    </v-row>
                                </div>

                            </div>


                        </div>
                        <v-btn small color="primary"
                               @click="print_preview_with_header_title_height(body_id,header_id,footer_id,'Deliver Reports')">
                            پرینت
                        </v-btn>
                        <v-btn small color="success">
                            <download-excel
                                    class="btn btn-default"
                                    :data="table_excel_with_sum(items_delivery_all,['count_truck','total_tonaje',
'total_employer_price',
'total_real_employer_price',
'total_driver_price',
'total_real_driver_price',])"
                                    :fields="table_header_to_excel_heaader(headers_deliver_all)"
                                    worksheet="My Worksheet"
                                    name="filename.xls"
                            >
                                خروجی اکسل
                            </download-excel>
                        </v-btn>

                    </v-card-text>
                    <v-card-text v-if="report_type==4">
                        <div class="container">
                            <v-row>

                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label class="col-form-label">
                                            از تاریخ
                                        </label>
                                        <div>
                                            <ThreeDatePicker @last_focus="another_focus_select('end_date_id_date_day')"
                                                             first_id="start_date_id_" v-model="start_date"/>
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label class="col-form-label">
                                            تا تاریخ
                                        </label>
                                        <div>
                                            <ThreeDatePicker
                                                    @last_focus="another_focus_inside('trucks1')"
                                                    first_id="end_date_id_" v-model="end_date"/>
                                        </div>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-row form class="form-group">
                                        <div dir="rtl">
                                            <treeselect
                                                    :matchKeys="['code']"
                                                    v-model="start_selected_truck"
                                                    :cacheOptions="false"
                                                    :options="trucks_all"
                                                    :multiple="true"
                                                    id="trucks1"
                                                    :defaultExpandLevel="1"
                                                    placeholder="جستجو کامیون"
                                                    :normalizer="normalizer_load_type"
                                            />
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col dir="rtl">
                                    <treeselect
                                            :matchKeys="['code']"
                                            v-model="selected_load_type"
                                            :cacheOptions="false"
                                            :multiple="true"
                                            :defaultExpandLevel="1"
                                            id="load_type_list_all"
                                            @select="another_focus_inside('origin_load_list_all')"
                                            :options="load_types_all"
                                            placeholder="جستجو نوع جنس"
                                            :normalizer="normalizer_discharge_place"
                                    />
                                </v-col>
                                <v-col dir="rtl">
                                    <treeselect
                                            :matchKeys="['code']"
                                            v-model="selected_discharge_place"
                                            :cacheOptions="false"
                                            :multiple="true"
                                            :defaultExpandLevel="1"
                                            id="discharge_place_list_all"
                                            @select="another_focus('geT_data_all')"
                                            :options="discharge_places_all"
                                            placeholder="جستجو محل تخلیه"
                                            :normalizer="normalizer_discharge_place"
                                    />
                                </v-col>
                                <v-col cols="1">
                                    <v-btn @click="get_data_seperate" small color="primary">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <div :id="body_id_seperate">
                                <div v-if="items_delivery_seperate.length>0">

                                    <VDataTable2
                                            dense
                                            fixed-header
                                            multi-sort
                                            height="400px"
                                            style="width: 100%"
                                            hide-default-footer
                                            disable-pagination
                                            class="margin-auto table-bordered"
                                            :headers="headers_deliver_seperate"
                                            :items-per-page="1000"
                                            :items="items_delivery_seperate"
                                    >
                                        <template v-slot:item.row_id="{item }">
                                            {{ item._row_index+1}}
                                        </template>
                                        <template v-slot:item.total_driver_price="{ item }">
                                            {{ get_currency(parseFloat(item.total_driver_price).toFixed(0) )}}
                                        </template>
                                        <template v-slot:item.total_employer_price="{ item }">
                                            {{ get_currency(parseFloat(item.total_employer_price).toFixed(0))}}
                                        </template>
                                        <template v-slot:item.total_real_driver_price="{ item }">
                                            {{ get_currency(parseFloat(item.total_real_driver_price).toFixed(0)) }}
                                        </template>
                                        <template v-slot:item.total_real_employer_price="{ item }">
                                            {{ get_currency(parseFloat(item.total_real_employer_price).toFixed(0))
                                            }}
                                        </template>
                                        <template slot="body.append">

                                            <tr class="pink--text">
                                                <th colspan="4" class="title">جمع کل</th>
                                                <th class="title">
                                                    {{get_currency(calculate_items(items_delivery_seperate,
                                                    'count_truck'))}}
                                                </th>
                                                <th class="title">
                                                    {{get_currency(calculate_items(items_delivery_seperate,
                                                    'total_tonaje'))}}
                                                </th>


                                            </tr>
                                        </template>
                                    </VDataTable2>
                                    <v-row style="text-align:right">
                                        <v-col cols="12">تعداد سرویس: {{get_currency(calculate_items(items_delivery_seperate,
                                            'count_truck'))}}
                                        </v-col>
                                        <v-col cols="12">جمع تناژ: {{get_currency(calculate_items(items_delivery_seperate,
                                            'total_tonaje'))}}
                                        </v-col>

                                    </v-row>
                                </div>

                            </div>


                        </div>
                        <v-btn small color="primary"
                               @click="print_preview_with_header_title_height(body_id_seperate,header_id_seperate,footer_id,'Deliver Reports')">
                            پرینت
                        </v-btn>
                        <v-btn small color="success">
                            <download-excel
                                    class="btn btn-default"
                                    :data="table_excel_with_sum(items_delivery_all,['count_truck','total_tonaje',
'total_employer_price',
'total_real_employer_price',
'total_driver_price',
'total_real_driver_price',])"
                                    :fields="table_header_to_excel_heaader(headers_deliver_all)"
                                    worksheet="My Worksheet"
                                    name="filename.xls"
                            >
                                خروجی اکسل
                            </download-excel>
                        </v-btn>

                    </v-card-text>
                    <v-card-text v-if="report_type==2">
                        <div class="container">
                            <v-row>
                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label class="col-form-label">
                                            از تاریخ
                                        </label>
                                        <div>
                                            <ThreeDatePicker
                                                    @last_focus="another_focus_select('2end_date_id_date_day')"
                                                    first_id="2start_date_id_"
                                                    v-model="start_date"/>
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label class="col-form-label">
                                            تا تاریخ
                                        </label>
                                        <div>
                                            <ThreeDatePicker
                                                    @last_focus="another_focus_inside('trucks_one1')"
                                                    first_id="2end_date_id_"
                                                    v-model="end_date"/>
                                        </div>
                                    </v-row>
                                </v-col>


                                <v-col cols="3">
                                    <v-row form class="form-group">
                                        <div dir="rtl">
                                            <treeselect
                                                    :matchKeys="['code']"
                                                    v-model="one_selected_truck"
                                                    :cacheOptions="false"
                                                    :options="trucks"
                                                    :multiple="false"
                                                    id="trucks_one1"
                                                    placeholder="جستجو کامیون"
                                                    :normalizer="normalizer_load_type"
                                            />
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col cols="1">
                                    <v-btn @click="get_data_one" small color="primary">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-card

                                    color="basil"
                                    flat
                                    :id="body_id_one_delivery"
                            >
                                <v-card-text v-if="items_delivery.length>0">
                                    <!--                                    <v-row style="margin-right: 20px">-->
                                    <!--                                        <div v-if="one_selected_truck!=null" class="chip">-->
                                    <!--                                            {{trucks.filter(x=>x.id==one_selected_truck)[0].name}}-->
                                    <!--                                        </div>-->
                                    <!--                                    </v-row>-->
                                    <VDataTable2
                                            dense
                                            hide-default-footer
                                            disable-pagination
                                            height="400"
                                            fixed-header
                                            multi-sort
                                            class="margin-auto table-bordered"
                                            :headers="headers_deliver_one"
                                            :items-per-page="1000"
                                            :items="items_delivery"
                                    >
                                        <template v-slot:item.row_id="{item }">
                                            {{ item._row_index+1}}
                                        </template>
                                        <template v-slot:item.driver_price="{ item }">
                                            {{ get_currency(parseFloat(item.driver_price).toFixed(0)) }}
                                        </template>
                                        <template v-slot:item.calculated_driver_price="{ item }">
                                            {{ get_currency(parseFloat(item.calculated_driver_price).toFixed(0)) }}
                                        </template>
                                        <template v-slot:item.calculated_employer_price="{ item }">
                                            {{ get_currency(parseFloat(item.calculated_employer_price).toFixed(0)) }}
                                        </template>
                                        <template slot="body.append">
                                            <tr class="pink--text">
                                                <th colspan="8" class="title">جمع کل</th>
                                                <th class="title">{{ get_currency(calculate_items(items_delivery,
                                                    'tonaje')) }}
                                                </th>
                                                <th colspan="2" class="title" style="text-align: center">{{
                                                    get_currency(parseFloat(calculate_items(items_delivery,
                                                    'calculated_driver_price')).toFixed(0)) }}
                                                </th>
                                            </tr>
                                        </template>
                                    </VDataTable2>

                                </v-card-text>

                            </v-card>
                            <v-row v-for="load_type in person_load_types" :key="load_type" style="text-align:right">
                                <v-col cols="12">{{items_delivery.filter(x=>x.load_type_id==load_type)[0].load_type}}
                                </v-col>
                                <v-col cols="12">جمع تناژ: {{
                                    get_currency(calculate_items(items_delivery.filter(x=>x.load_type_id==load_type),
                                    'tonaje')) }}
                                </v-col>
                                <v-col cols="12">جمع کل: {{
                                    get_currency(parseFloat(calculate_items(items_delivery.filter(x=>x.load_type_id==load_type),
                                    'calculated_driver_price')).toFixed(0)) }}
                                </v-col>
                            </v-row>
                            <v-btn small color="primary"
                                   @click="print_with_header_title_height(body_id_one_delivery,header_id_one_truck,footer_id,'Deliver Reports')">
                                پرینت
                            </v-btn>
                            <v-btn small color="success">
                                <download-excel
                                        class="btn btn-default"
                                        :data="table_excel_with_sum(items_delivery,['tonaje',
'calculated_driver_price'])"
                                        :fields="table_header_to_excel_heaader(headers_deliver_one)"
                                        worksheet="My Worksheet"
                                        name="filename.xls"
                                >
                                    خروجی اکسل
                                </download-excel>
                            </v-btn>
                        </div>

                    </v-card-text>
                    <v-card-text v-if="report_type==3">
                        <div class="container">
                            <v-row>
                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label class="col-form-label">
                                            از تاریخ
                                        </label>
                                        <div>
                                            <ThreeDatePicker
                                                    @last_focus="another_focus_select('3end_date_id_date_day')"
                                                    first_id="3start_date_id_"
                                                    v-model="start_date"/>
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label class="col-form-label">
                                            تا تاریخ
                                        </label>
                                        <div>
                                            <ThreeDatePicker
                                                    @last_focus="another_focus_inside('trucks3')"
                                                    first_id="3end_date_id_"
                                                    v-model="end_date"/>
                                        </div>
                                    </v-row>
                                </v-col>


                                <v-col cols="3">
                                    <v-row form class="form-group">
                                        <div dir="rtl">
                                            <treeselect
                                                    :matchKeys="['code']"
                                                    v-model="start_selected_truck"
                                                    :cacheOptions="false"
                                                    :options="trucks_all"
                                                    :multiple="true"
                                                    id="trucks3"
                                                    :defaultExpandLevel="1"
                                                    placeholder="جستجو کامیون"
                                                    :normalizer="normalizer_load_type"
                                            />
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col cols="1">
                                    <v-btn @click="get_data_all_sort" small color="primary">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-card
                                    v-show="false"
                                    color="basil"
                                    flat
                                    :id="body_id_delivery_sort"
                            >
                                <!--                                    <v-row style="margin-right: 20px">-->
                                <!--                                        <div v-if="one_selected_truck!=null" class="chip">-->
                                <!--                                            {{trucks.filter(x=>x.id==one_selected_truck)[0].name}}-->
                                <!--                                        </div>-->
                                <!--                                    </v-row>-->
                                <div class="no-padding-table" v-for="sorte in items_delivery_all_sort.filter(x=>x.length>0)" :key="sorte.id">
                                    <!--                                    <v-card-text >-->

                                    <v-row>
                                        <v-col cols="3">
                                            <div>کد کامیون: {{trucks.filter(x=>x.id==sorte[0].truck_id)[0].code}}</div>

                                        </v-col>
                                        <v-col cols="3">
                                            <div>شماره پلاک: {{trucks.filter(x=>x.id==sorte[0].truck_id)[0].plate}}</div>

                                        </v-col>
                                        <v-col cols="3">
                                            <div>نام کامیوندار:
                                                {{trucks.filter(x=>x.id==sorte[0].truck_id)[0].driver}}</div>

                                        </v-col>
                                        <v-col cols="3">
                                            <div>از تاریخ {{start_date}}</div>
                                            <div>تا تاریخ {{end_date}}</div>

                                        </v-col>
                                    </v-row>
                                    <VDataTable2
                                            dense
                                            hide-default-footer
                                            disable-pagination
                                            fixed-header
                                            multi-sort
                                            :sort-by.sync="non_profit_sortBy"
                                            :sort-desc.sync="non_profit_sortDesc"
                                            class="margin-auto table-bordered"
                                            :headers="headers_deliver_one"
                                            :items-per-page="1000"
                                            :items="sorte"
                                    >
                                        <template v-slot:item.row_id="{item }">
                                          <label  style="font-size: 12px">  {{ item._row_index+1}}</label>
                                        </template>


                                        <template v-slot:item.driver_price="{ item }">
                                          <label  style="font-size: 12px">{{ get_currency(parseFloat(item.driver_price).toFixed(0)) }}</label>
                                        </template>

                                        <template v-slot:item.doc_date_persian="{ item }">
                                           <label style="font-size: 12px">{{ item.doc_date_persian }}</label>
                                        </template>
                                        <template v-slot:item.barname="{ item }">
                                           <label style="font-size: 12px">{{ item.barname }}</label>
                                        </template>
                                        <template v-slot:item.load_type="{ item }">
                                           <label style="font-size: 12px">{{ item.load_type }}</label>
                                        </template>
                                        <template v-slot:item.origin_load="{ item }">
                                           <label style="font-size: 12px">{{ item.origin_load }}</label>
                                        </template>
                                        <template v-slot:item.discharge_place_code="{ item }">
                                           <label style="font-size: 12px">{{ item.discharge_place_code }}</label>
                                        </template>
                                        <template v-slot:item.discharge_place="{ item }">
                                           <label style="font-size: 12px">{{ item.discharge_place }}</label>
                                        </template>
                                        <template v-slot:item.discharge_place_address="{ item }">
                                           <label style="font-size: 12px">{{ item.discharge_place_address }}</label>
                                        </template>
                                        <template v-slot:item.tonaje="{ item }">
                                           <label style="font-size: 12px">{{ item.tonaje }}</label>
                                        </template>
                                        <template v-slot:item.calculated_driver_price="{ item }">
                                            {{ get_currency(parseFloat(item.calculated_driver_price).toFixed(0)) }}
                                        </template>
                                        <template v-slot:item.calculated_employer_price="{ item }">
                                            {{ get_currency(parseFloat(item.calculated_employer_price).toFixed(0)) }}
                                        </template>
                                        <template slot="body.append">
                                            <tr class="pink--text">
                                                <th colspan="8" class="title">جمع کل</th>
                                                <th class="title">{{ get_currency(calculate_items(sorte,
                                                    'tonaje')) }}
                                                </th>
                                                <th colspan="2" class="title" style="text-align: center">{{
                                                    get_currency(calculate_items(sorte,
                                                    'calculated_driver_price')) }}
                                                </th>
                                                <!--                                                            <th class="title">{{ sumField('carbs') }}</th>-->
                                                <!--                                                            <th class="title">{{ sumField('protein') }}</th>-->
                                            </tr>
                                        </template>
                                    </VDataTable2>
                                    <v-row v-for="load_type in print_person_load_types.filter(x=> sorte.filter(x2=>x2.load_type_id==x).length>0)"
                                           :key="load_type" style="text-align:right">
                                        <v-col cols="12">{{sorte.filter(x=>x.load_type_id==load_type)[0].load_type}}
                                        </v-col>
                                        <v-col cols="12">جمع تناژ: {{
                                            get_currency(calculate_items(sorte.filter(x=>x.load_type_id==load_type),
                                            'tonaje')) }}
                                        </v-col>
                                        <v-col cols="12">جمع کل: {{
                                            get_currency(parseFloat(calculate_items(sorte.filter(x=>x.load_type_id==load_type),
                                            'calculated_driver_price')).toFixed(0)) }}
                                        </v-col>
                                    </v-row>
                                    <!--                                    </v-card-text>-->
                                    <!--                                    <v-row style="text-align:right">-->
                                    <!--                                        <v-col cols="12">جمع تناژ: {{ get_currency(calculate_items(sorte, 'tonaje')) }}-->
                                    <!--                                        </v-col>-->
                                    <!--                                        <v-col cols="12">جمع کل: {{ get_currency(calculate_items(sorte,-->
                                    <!--                                            'calculated_driver_price')) }}-->
                                    <!--                                        </v-col>-->
                                    <!--                                    </v-row>-->
                                    <div class="pagebreak"></div>
<!--                                                                        <div style="break-after:page"></div>-->
<!--                                                                        <p style="page-break-after: always;">&nbsp;</p>-->
<!--                                                                        <p style="page-break-before: always;">&nbsp;</p>-->
                                </div>


                            </v-card>
                            <v-btn v-if="items_delivery_all_sort.length>0"
                                   small color="primary"
                                   @click="print_with_header_title_height(body_id_delivery_sort,header_id_select_truck,footer_id,'Deliver Reports')">
                                پرینت
                            </v-btn>
                        </div>

                    </v-card-text>

                </v-card>
            </v-col>

        </v-row>
        <div v-show="false" :id="header_id">
            <div style="margin-right: 50px;margin-left: 50px;margin-bottom: 70px">
                <v-row style="justify-content:center">
                    <strong style="font-size: large">{{get_company_name()}}</strong>
                </v-row>

                <v-row style="justify-content:center">
                    <strong>نمایش کل کارکرد کامیونداران</strong>
                </v-row>
                <v-row>

                    <v-col cols="3">
                        <p>از تاریخ {{start_date}}</p>
                        <p>تا تاریخ {{end_date}}</p>

                    </v-col>

                </v-row>

            </div>

        </div>
        <div v-show="false" :id="header_id_seperate">
            <div style="margin-right: 50px;margin-left: 50px;margin-bottom: 70px">
                <v-row style="justify-content:center">
                    <strong style="font-size: large">{{get_company_name()}}</strong>
                </v-row>

                <v-row style="justify-content:center">
                    <strong>نمایش کل کارکرد کامیونداران(به تفکیک)</strong>
                </v-row>
                <v-row>

                    <v-col cols="3">
                        <p>از تاریخ {{start_date}}</p>
                        <p>تا تاریخ {{end_date}}</p>

                    </v-col>

                </v-row>

            </div>

        </div>
        <div v-show="false" :id="header_id_one_truck">
            <div style="margin-right: 50px;margin-left: 50px">
                <v-row style="justify-content:center">
                    <strong style="font-size: large">{{get_company_name()}}</strong>
                </v-row>

                <v-row style="justify-content:center">
                    <strong>گزارش کارکرد کامیون</strong>
                </v-row>
                <v-row v-if="one_selected_truck!=null">

                    <v-col cols="3">
                        <p>کد کامیون: {{trucks.filter(x=>x.id==one_selected_truck)[0].code}}</p>

                    </v-col>
                    <v-col cols="3">
                        <p>شماره پلاک: {{trucks.filter(x=>x.id==one_selected_truck)[0].plate}}</p>

                    </v-col>
                    <v-col cols="3">
                        <p>نام کامیوندار: {{trucks.filter(x=>x.id==one_selected_truck)[0].driver}}</p>

                    </v-col>
                    <v-col cols="3">
                        <p>از تاریخ {{start_date}}</p>
                        <p>تا تاریخ {{end_date}}</p>

                    </v-col>

                </v-row>

            </div>

        </div>
        <div v-show="false" :id="header_id_select_truck"
        >
            <div style="margin-right: 50px;margin-left: 50px;">
                <v-row style="justify-content:center">
                    <strong style="font-size: large">{{get_company_name()}}</strong>
                </v-row>

                <v-row style="justify-content:center">
                    <strong>گزارش کارکرد کامیون</strong>
                </v-row>

            </div>

        </div>
        <div v-show="false" :id="footer_id" class="border-dark">
            <v-row style="border: 1px solid #000">
                <v-col cols="12" style="text-align: start">
                    <label>{{get_company_address()}}</label>
                </v-col>
            </v-row>
        </div>

    </div>
</template>
<script>
    import Vue from 'vue'
    import {bus} from '../../main'
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import ThreeDatePicker from "../includes/ThreeDatePicker";

    export default {
        name: 'ReportDriverDetail',
        components: {
            Treeselect,
            ThreeDatePicker,
        },
        data() {
            return {
                report_type: 1,
                header_id: "print_header_ReportDriverDetail" + new Date().getTime() + this.$vnode.tag,
                header_id_seperate: "print_header_seperate_ReportDriverDetail" + new Date().getTime() + this.$vnode.tag,
                header_id_one_truck: "print_header_one_truck_ReportDriverDetail" + new Date().getTime() + this.$vnode.tag,
                header_id_select_truck: "print_header_select_truck_ReportDriverDetail" + new Date().getTime() + this.$vnode.tag,
                footer_id: "print_footer_ReportDriverDetail" + new Date().getTime() + this.$vnode.tag,
                body_id: "print_body_ReportDriverDetail" + new Date().getTime() + this.$vnode.tag,
                body_id_seperate: "print_body_seperate_ReportDriverDetail" + new Date().getTime() + this.$vnode.tag,
                body_id_one_delivery: "print_body_one_delivey_ReportDriverDetail2" + new Date().getTime() + this.$vnode.tag,
                body_id_delivery_sort: "print_body_delivey_sort_ReportDriverDetail2" + new Date().getTime() + this.$vnode.tag,
                tab: null,
                confirm_delete_name: 'confirm_delete' + new Date().getTime() + '_' + this.$vnode.tag,
                items_delivery_all: [],
                items_delivery_all_sort: [],
                items_delivery_seperate: [],
                items_delivery: [],
                items_payment: [],
                items_accounting: [],
                status_form: 0,
                trucks: [],
                person_load_types: [],
                print_person_load_types: [],
                trucks_all: [],
                start_selected_truck: null,
                one_selected_truck: null,
                start_date: null,
                end_date: null,
                origin_loads: [],
                origin_loads_all: [],
                load_types: [],
                load_types_all: [],
                selected_load_type: [],
                selected_origin_load: [],
                discharge_places_all: [],
                selected_discharge_place: [],

                headers_deliver_all: [
                    {
                        text: 'ردیف',
                        value: 'row_id'
                    },

                    {
                        text: 'کد کامیون',
                        value: 'truck_code'
                    },
                    {
                        text: 'نام کامیون',
                        value: 'truck_name',
                        width: '20%',
                    },
                    {
                        text: 'شماره کامیون',
                        value: 'truck_plate'
                    },
                    {
                        text: 'تعداد سرویس',
                        value: 'count_truck'
                    },
                    // {
                    //     text: 'نام مالک',
                    //     value: 'truck_driver'
                    // },
                    {
                        text: 'جمع تناژ',
                        value: 'total_tonaje'
                    },

                    {
                        text: 'جمع مبلغ کارفرما',
                        value: 'total_employer_price'
                    },
                    {
                        text: 'جمع مبلغ مورد محاسبه کارفرما',
                        value: 'total_real_employer_price'
                    },
                    {
                        text: 'جمع مبلغ کامیوندار',
                        value: 'total_driver_price'
                    },

                    {
                        text: 'جمع مبلغ مورد محاسبه کامیوندار',
                        value: 'total_real_driver_price'
                    },

                ],
                headers_deliver_seperate: [
                    {
                        text: 'ردیف',
                        value: 'row_id'
                    },

                    {
                        text: 'کد کامیون',
                        value: 'truck_code'
                    },
                    {
                        text: 'نام کامیون',
                        value: 'truck_name',
                        width: '20%',
                    },
                    {
                        text: 'شماره کامیون',
                        value: 'truck_plate'
                    },
                    {
                        text: 'تعداد سرویس',
                        value: 'count_truck'
                    },
                    // {
                    //     text: 'نام مالک',
                    //     value: 'truck_driver'
                    // },
                    {
                        text: 'جمع تناژ',
                        value: 'total_tonaje'
                    },

                    {
                        text: 'نوع جنس',
                        value: 'load_type'
                    },
                    {
                        text: 'کد محل تخلیه',
                        value: 'discharge_place_code'
                    }, {
                        text: 'محل تخلیه',
                        value: 'discharge_place'
                    },
                    // {
                    //     text: 'جمع مبلغ کامیوندار',
                    //     value: 'total_driver_price'
                    // },
                    //
                    // {
                    //     text: 'جمع مبلغ مورد محاسبه کامیوندار',
                    //     value: 'total_real_driver_price'
                    // },

                ],
                non_profit_sortBy: ['doc_date_persian', 'barname'],
                non_profit_sortDesc: false,
                headers_deliver_one: [
                    {
                        text: 'ردیف',
                        value: 'row_id'
                    },
                    // {
                    //     text: 'تاریخ ثبت',
                    //     value: 'created_at'
                    // }, {
                    //     text: 'تاریخ ویرایش',
                    //     value: 'updated_at'
                    // },
                    {
                        text: 'تاریخ',
                        value: 'doc_date_persian'
                    },
                    {
                        text: 'شماره بارنامه',
                        value: 'barname'
                    },
                    // {
                    //     text: 'شماره سند',
                    //     value: 'doc_date_persian'
                    // },

                    {
                        text: 'جنس بار',
                        value: 'load_type'
                    },
                    {
                        text: 'مبدا بارگیری',
                        value: 'origin_load'
                    },
                    {
                        text: 'کد محل تخلیه',
                        value: 'discharge_place_code'
                    },
                    {
                        text: 'محل تخلیه',
                        value: 'discharge_place'
                    },

                    {
                        text: 'آدرس',
                        value: 'discharge_place_address'
                    },
                    {
                        text: 'تناژ',
                        value: 'tonaje'
                    },
                    // {
                    //     text: 'نام کامیون',
                    //     value: 'truck_name'
                    // },


                    {
                        text: 'نرخ حمل',
                        value: 'driver_price'
                    },
                    {
                        text: 'جمع کل',
                        value: 'calculated_driver_price'
                    },
                    // {
                    //     text: 'نرخ حمل کارفرما',
                    //     value: 'calculated_employer_price'
                    // },

                ],
                headers_pre_payment: [
                    {
                        text: 'ردیف',
                        value: 'row_id'
                    },
                    {
                        text: 'شماره سند',
                        value: 'id'
                    },
                    {
                        text: 'تاریخ سند',
                        value: 'persian_date'
                    },
                    {
                        text: 'نام کامیون',
                        value: 'truck_name'
                    },
                    {
                        text: 'نام کامیوندار',
                        value: 'truck_driver'
                    },
                    {
                        text: 'مبلغ دریافتی',
                        value: 'price'
                    },
                    {
                        text: 'توضیحات',
                        value: 'summary'
                    },
                ],
                headers_accounting: [
                    {
                        text: 'ردیف',
                        value: 'row_id'
                    },
                    {
                        text: 'نوع سند',
                        value: 'doc_type'
                    },
                    {
                        text: 'تاریخ سند',
                        value: 'persian_date'
                    },
                    {
                        text: 'شماره سند',
                        value: 'doc_id'
                    },
                    {
                        text: 'شرح سند',
                        value: 'summary'
                    },
                    {
                        text: 'مبلغ بدهکار',
                        value: 'debtor'
                    },
                    {
                        text: 'مبلغ بستانکار',
                        value: 'creditor'
                    },
                ],

                normalizer_origin(node) {
                    return {
                        id: node.id,
                        label: node.code + ' - ' + node.name,
                        code: node.code,

                    }
                },
                normalizer_load_type(node) {
                    return {
                        id: node.id,
                        label: node.code + ' - ' + node.name,
                        code: node.code,

                    }
                },
                normalizer_discharge_place(node) {
                    return {
                        id: node.id,
                        label: node.code + ' - ' + node.name,
                        code: node.code,

                    }
                },
            }
        },
        mounted() {
            // this.get_data()

            this.get_trucks()
            this.get_discharge_places()
            this.get_load_types()


            this.start_date = this.miladi_to_jalali(this.get_today())
            this.end_date = this.miladi_to_jalali(this.get_today())

            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == 'true') {
                    this.delete_item()

                } else {
                    this.status_form = 0
                }
            })
        },
        watch: {
            start_date: function () {
                console.log('start date changedd', this.start_date)
            },
            // end_date: function () {
            //   this.get_data()
            // },
            //
            // start_selected_truck: function () {
            //   this.get_data_all()
            // },
            // one_selected_truck: function () {
            //   // localStorage.setItem("driver_detail_trucks",JSON.stringify(this.start_selected_truck))
            //   this.get_data_one()
            // },

        },
        methods: {
            get_discharge_places() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/discharge_places/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        // self.discharge_places = [{id: 0, name: "همه موارد", code: ""}]
                        self.discharge_places_all = [{id: 0, name: "همه موارد", code: "", children: []}]
                        self.discharge_places = [];
                        response.data.data.forEach(function (val) {
                            self.discharge_places_all[0].children.push(val)
                            self.discharge_places.push(val)
                        })
                        self.selected_discharge_place = JSON.parse(localStorage.getItem("driver_detail_discharge"))

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }
                    if (self.$route.params.doc_id != null) {
                        self.status_form = self.$route.params.doc_id
                        self.get_data()
                    }
                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            get_load_types() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/load_type/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        // self.load_types = [{id: 0, name: "همه موارد", code: ""}]
                        // response.data.data.forEach(function (val) {
                        //     self.load_types.push(val)
                        // })
                        self.load_types_all = [{id: 0, name: "همه موارد", code: "", children: []}]
                        self.load_types = []
                        response.data.data.forEach(function (val) {
                            self.load_types_all[0].children.push(val)
                            self.load_types.push(val)
                        })
                        self.selected_load_type = JSON.parse(localStorage.getItem("driver_detail_load_type"))

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    console.log(error)
                })

            },
            real_paying_driver(item) {

                var price = item.driver_price
                var tonaje = parseFloat(item.tonaje)
                if (item.tonaje_limit == 1) {
                    if (item.truck_type == 1 && tonaje > item.tak_limit_tonaje) {
                        tonaje = item.tak_limit_tonaje
                    }
                    if (item.truck_type == 2 && tonaje > item.joft_limit_tonaje) {
                        tonaje = item.joft_limit_tonaje
                    }
                }
                return (parseFloat(price) * tonaje)
            },
            deliver_employer(item) {

                var price = item.employer_price
                var tonaje = parseFloat(item.tonaje)
                if (item.tonaje_limit == 1) {
                    if (item.truck_type == 1 && tonaje > item.tak_limit_tonaje) {
                        tonaje = item.tak_limit_tonaje
                    }
                    if (item.truck_type == 2 && tonaje > item.joft_limit_tonaje) {
                        tonaje = item.joft_limit_tonaje
                    }
                }
                return (parseFloat(price) * tonaje)

            },

            get_data_seperate() {
                if (this.start_selected_truck == null) {
                    return
                }
                localStorage.setItem("driver_detail_trucks", JSON.stringify(this.start_selected_truck))
                localStorage.setItem("driver_detail_discharge", JSON.stringify(this.selected_discharge_place))
                localStorage.setItem("driver_detail_load_type", JSON.stringify(this.selected_load_type))

                this.get_delivery_seperate()
                // this.get_payments()
                // this.get_accountings()
            },
            get_data_all() {
                if (this.start_selected_truck == null) {
                    return
                }
                localStorage.setItem("driver_detail_trucks", JSON.stringify(this.start_selected_truck))

                this.get_delivery_all()
                // this.get_payments()
                // this.get_accountings()
            },
            get_data_all_sort() {
                if (this.start_selected_truck == null) {
                    return
                }
                localStorage.setItem("driver_detail_trucks_sort", JSON.stringify(this.start_selected_truck))

                this.get_delivery_all_sort()
                // this.get_payments()
                // this.get_accountings()
            },
            get_data_one() {
                if (this.one_selected_truck == null) {
                    return
                }
                this.get_delivery_one()
                this.get_payments()
                this.get_accountings()
            },
            get_delivery_all() {
                var self = this
                const formData = new FormData()
                formData.append('start_date', this.jalali_to_miladi(this.start_date))
                formData.append('end_date', this.jalali_to_miladi(this.end_date))
                if (this.start_selected_truck.filter(x => x == 0).length > 0) {
                    console.log("trucks", this.start_selected_truck)

                    var final_trucks = [];
                    this.trucks.forEach(function (val) {
                        final_trucks.push(val.id);
                    })
                    formData.append('truck_id', final_trucks)

                } else {
                    formData.append('truck_id', this.start_selected_truck)
                }
                this.axios.post('/api/delivery_document/select_by_multiple_truck', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        // self.items_delivery = response.data.data
                        self.items_delivery_all = response.data.data.map((item, row_id) => {
                            return {...item, row_id}
                        })

                        self.items_delivery_all.forEach(function (val) {
                            val.tonaje = parseFloat(val.tonaje).toFixed(3)

                            // val.calculated_driver_price = self.real_paying_driver(val)
                            // val.calculated_employer_price = self.deliver_employer(val)
                        })
                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            get_delivery_seperate() {
                var self = this
                const formData = new FormData()
                formData.append('start_date', this.jalali_to_miladi(this.start_date))
                formData.append('end_date', this.jalali_to_miladi(this.end_date))
                if (this.start_selected_truck.filter(x => x == 0).length > 0) {
                    console.log("trucks", this.start_selected_truck)

                    var final_trucks = [];
                    this.trucks.forEach(function (val) {
                        final_trucks.push(val.id);
                    })
                    formData.append('truck_id', final_trucks)
                    //***************************************************

                    if (this.selected_discharge_place.includes(0)) {
                        var final_discharge = [];
                        this.discharge_places.forEach(function (val) {
                            final_discharge.push(val.id);
                        })
                        formData.append('discharge_id', final_discharge)
                    } else {
                        formData.append('discharge_id', this.selected_discharge_place)
                    }
                    //***************************************************
                    if (this.selected_load_type.includes(0)) {
                        var final_load_type = [];
                        this.load_types.forEach(function (val) {
                            final_load_type.push(val.id);
                        })
                        formData.append('load_type_id', final_load_type)
                    } else {
                        formData.append('load_type_id', this.selected_load_type)
                    }
                    //***************************************************

                } else {
                    formData.append('truck_id', this.start_selected_truck)
                }
                this.axios.post('/api/delivery_document/select_by_multiple_truck_seperate', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        // self.items_delivery = response.data.data
                        self.items_delivery_seperate = response.data.data.map((item, row_id) => {
                            return {...item, row_id}
                        })

                        self.items_delivery_seperate.forEach(function (val) {
                            val.tonaje = parseFloat(val.tonaje).toFixed(3)

                            // val.calculated_driver_price = self.real_paying_driver(val)
                            // val.calculated_employer_price = self.deliver_employer(val)
                        })
                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            get_delivery_all_sort() {
                var self = this
                const formData = new FormData()
                formData.append('start_date', this.jalali_to_miladi(this.start_date))
                formData.append('end_date', this.jalali_to_miladi(this.end_date))
                if (this.start_selected_truck.filter(x => x == 0).length > 0) {
                    console.log("trucks", this.start_selected_truck)

                    var final_trucks = [];
                    this.trucks.forEach(function (val) {
                        final_trucks.push(val.id);
                    })
                    formData.append('truck_id', final_trucks)

                } else {
                    formData.append('truck_id', this.start_selected_truck)
                }
                this.axios.post('/api/delivery_document/select_by_multiple_truck_sort', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        // self.items_delivery = response.data.data
                        self.print_person_load_types = [];
                        response.data.data.forEach(function (val) {
                            val.forEach(function (val2, index) {

                                if (!self.print_person_load_types.includes(val2.load_type_id)) {
                                    self.print_person_load_types.push(val2.load_type_id)
                                }
                            })
                        })
                        self.items_delivery_all_sort = response.data.data

                        self.items_delivery_all_sort.forEach(function (val2) {
                            // val2 = val2.map((item, row_id) => {
                            //     return {...item, row_id}
                            // })
                            val2.forEach(function (val, index) {
                                // val = val.map((item, row_id) => {
                                //     return {...item, row_id}
                                // })
                                val.row_id = index
                                val.calculated_driver_price = self.real_paying_driver(val)
                                val.calculated_employer_price = self.deliver_employer(val)
                                val.tonaje = parseFloat(val.tonaje).toFixed(3)
                            })

                        })

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            get_delivery_one() {
                var self = this
                const formData = new FormData()
                formData.append('start_date', this.jalali_to_miladi(this.start_date))
                formData.append('end_date', this.jalali_to_miladi(this.end_date))

                formData.append('truck_id', this.one_selected_truck)
                this.axios.post('/api/delivery_document/select_by_truck', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        // self.items_delivery = response.data.data
                        self.items_delivery = response.data.data.map((item, row_id) => {
                            return {...item, row_id}
                        })

                        //

                        // self.items_delivery=  self.items_delivery.concat(self.items_delivery);
                        // self.items_delivery= self.items_delivery.concat(self.items_delivery);
                        // self.items_delivery= self.items_delivery.concat(self.items_delivery);
                        // self.items_delivery = self.items_delivery.map((item, row_id) => {
                        //     return {...item, row_id}
                        // })
                        self.person_load_types = [];
                        self.items_delivery.forEach(function (val) {
                            val.calculated_driver_price = self.real_paying_driver(val)
                            val.calculated_employer_price = self.deliver_employer(val)
                            val.tonaje = parseFloat(val.tonaje).toFixed(3)
                            if (!self.person_load_types.includes(val.load_type_id)) {
                                self.person_load_types.push(val.load_type_id)
                            }
                        })
                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            get_payments() {
                var self = this
                const formData = new FormData()
                formData.append('start_date', this.jalali_to_miladi(this.start_date))
                formData.append('end_date', this.jalali_to_miladi(this.end_date))

                formData.append('truck_id', this.one_selected_truck)
                this.axios.post('/api/pre_payment/select_by_truck', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.items_payment = response.data.data.map((item, row_id) => {
                            return {...item, row_id}
                        })

                        // self.items.forEach(function (val) {
                        //   val.calculated_driver_price = self.real_paying_driver(val)
                        //   val.calculated_employer_price = self.deliver_employer(val)
                        //   val.tonaje = parseFloat(val.tonaje).toFixed(3)
                        // })
                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            get_accountings() {
                var self = this
                const formData = new FormData()
                formData.append('start_date', this.jalali_to_miladi(this.start_date))
                formData.append('end_date', this.jalali_to_miladi(this.end_date))

                formData.append('truck_id', this.one_selected_truck)
                this.axios.post('/api/truck_account/select_by_truck', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.items_accounting = response.data.data.map((item, row_id) => {
                            return {...item, row_id}
                        })

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },

            get_trucks() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/trucks/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.trucks_all = [{id: 0, name: "همه کامیون داران", code: "", children: []}]
                        self.trucks = []
                        response.data.data.sort((a, b) => a.code.localeCompare(b.code, undefined, {
                            numeric: true,
                            sensitivity: 'base'
                        }));

                        response.data.data.forEach(function (val) {
                            self.trucks.push(val)
                            self.trucks_all[0].children.push(val)
                        })
                        self.start_selected_truck = JSON.parse(localStorage.getItem("driver_detail_trucks"))

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)
                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            edit_item(item) {
                this.$router.push({path: '/edit-delivery-document/' + item.id})
            },
            delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal('هشدار', 'آیا مایل به حذف این ردیف هستید؟', ['تایید'], this.confirm_delete_name)
                this.status_form = item.id
            },
            delete_item() {
                const self = this
                const formData = new FormData()
                const url = '/api/delivery_document/delete'
                formData.append('id', this.status_form)

                this.axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res)
                    self.status_form = 0

                    self.get_data()

                })
                    .catch(function (error) {
                        console.log(error)
                    })
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },

        }
    }
</script>
<style>
.no-padding-table td{
  padding: 1px!important;
}
</style>